/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stripeHandler = __webpack_require__(1);

var _stripeHandler2 = _interopRequireDefault(_stripeHandler);

var _modalHandler = __webpack_require__(2);

var _modalHandler2 = _interopRequireDefault(_modalHandler);

var _liveUpdate = __webpack_require__(3);

var _liveUpdate2 = _interopRequireDefault(_liveUpdate);

var _missingImgHandler = __webpack_require__(4);

var _missingImgHandler2 = _interopRequireDefault(_missingImgHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(window).on('load', function () {

  //Disables autoscroll to last position on reload
  if (history && 'scrollRestoration' in history) history.scrollRestoration = 'manual';

  //Scrolls to the top of the page to show any updates
  $(window).scrollTop(0);

  // console.log('main.js heard doc ready event');
  var orderExists = document.getElementById('orderExists').getAttribute('data-value') === 'true';
  if (orderExists) {
    var infoElement = document.getElementById('order-info-hidden');

    var status = infoElement.getAttribute('data-status');
    var token = infoElement.getAttribute('data-token');
    var stripePublicKey = infoElement.getAttribute('data-stripe-public-key');

    (0, _missingImgHandler2.default)();
    (0, _modalHandler2.default)();
    if (status == 'sent') (0, _stripeHandler2.default)(stripePublicKey);
    (0, _liveUpdate2.default)(token);
  };
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Sends stripe token to server upon form submission
function stripeTokenHandler(token) {
  var form = document.getElementById('payment-form');
  var hiddenInput = document.createElement('input');
  hiddenInput.setAttribute('type', 'hidden');
  hiddenInput.setAttribute('name', 'stripeToken');
  hiddenInput.setAttribute('value', token.id);
  form.appendChild(hiddenInput);

  form.submit();
}

//Adds stripe element to form, responds to error and submit events
function stripeHandler(stripePublicKey) {
  var form = document.getElementById('payment-form');
  var button = document.getElementById('payment-button');
  button.disabled = true;

  var stripe = Stripe(stripePublicKey);
  var elements = stripe.elements();
  var style = {
    base: {
      color: '#32325f',
      // lineHeight: '24px',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4'
      }
    },
    invalid: {
      color: '#fa755a',
      iconColor: '#fa755a'
    }
  };

  var card = elements.create('card', { style: style });
  card.mount('#card-element');

  // Handle real-time validation errors from the card Element.
  card.addEventListener('change', function (event) {
    var displayError = document.getElementById('card-errors');
    if (event.error) {
      displayError.textContent = event.error.message;
      button.disabled = true;
    } else {
      displayError.textContent = '';
      event.empty ? button.disabled = true : button.disabled = false;
    }
  });

  // Handle form submission
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    //Check if form has already been successfully submitted 
    // to prevent multiple submissions
    if (!form.classList.contains('submitted')) {
      // Form set as submitted
      form.classList.add('submitted');
      stripe.createToken(card).then(function (result) {
        if (result.error) {
          // Inform the user if there was an error
          var errorElement = document.getElementById('card-errors');
          errorElement.textContent = result.error.message;
          // Remove submitted class to allow resubmission
          form.classList.remove('submitted');
        } else {
          // Send the token to your server
          stripeTokenHandler(result.token);
        }
      });
    };
  });
}

module.exports = stripeHandler;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function modalHandler() {
  var modal = document.getElementById('myModal');

  var itemImages = document.getElementsByClassName('item-image');

  //Adds click listener to non-placeholder item images to render large image in modal

  var _loop = function _loop(i) {
    var itemImage = itemImages[i];
    var modalImage = document.getElementById('modal-image');
    var caption = document.getElementById('caption');

    if (!itemImage.classList.contains('placeholder')) {
      itemImage.onclick = function () {
        modal.style.display = "block";
        modalImage.src = this.src;
        caption.innerHTML = this.alt;
      };
    }
  };

  for (var i = 0; i < itemImages.length; i += 1) {
    _loop(i);
  }

  var span = document.getElementsByClassName('close')[0];
  modal.onclick = function () {
    modal.style.display = "none";
  };
}

module.exports = modalHandler;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function liveUpdate(token) {
  var HOST = location.origin.replace(/^http/, 'ws');
  var ws = new WebSocket(HOST);

  //Tells socket server to add client when connection is established
  ws.onopen = function () {
    // console.log('websocket connection opened');
    var msg = {
      action: 'addClient',
      payload: { token: token }
    };
    ws.send(JSON.stringify(msg));
  };
  //Reloads the page whenever app webhook hears an update (to load updated order)
  ws.onmessage = function (msg) {
    // console.log('websocket heard message from server');
    var data = JSON.parse(msg.data);
    if (data.action === 'update') {
      location.reload();
    }
  };

  // ws.onerror = error => {
  //   console.log('a websocket error occurred:', error);
  // }
}

module.exports = liveUpdate;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Replaces unloaded item images with missing image icon
function missingImgHandler() {
  var images = document.getElementsByClassName('item-image');
  for (var i = 0; i < images.length; i += 1) {
    var image = images[i];
    // console.log('src:', image.getAttribute('src'));
    // console.log('complete:', image.complete);
    // console.log('naturalWidth:', image.naturalWidth);
    if (!image.complete || image.naturalWidth === 0) {
      // console.log('replacing image...')
      var altText = image.getAttribute('alt');
      var placeholder = document.createElement('img');
      placeholder.classList.add('item-image');
      placeholder.classList.add('placeholder');
      placeholder.setAttribute('src', 'https://s3-us-west-1.amazonaws.com/pg-retail-inventory/pg-images/Glasses+Placeholder+Image-2.jpg');
      placeholder.setAttribute('alt', altText);
      placeholder.setAttribute('title', altText);
      image.replaceWith(placeholder);
    }
  }
}

module.exports = missingImgHandler;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bundle.js